import React from 'react';
import PropTypes from 'prop-types';
import { Content, Filters, Modals, ToolbarActions } from './Components';
import ContainerHeader from './ContainerHeader';
const ContentContainer = props => {
  const {
    data,
    entity,
    children,
    onlyToolbars,
    titleAndFilters,
    noHeader
  } = props;
  const filtersContent = children.find(x => x.type.name === Filters.name);
  const toolbarActionsContent = children.find(x => x.type.name === ToolbarActions.name);
  const modalsContent = children.find(x => x.type.name === Modals.name);
  const onFilterFormChange = formData => {
    filtersContent.props.onChange && filtersContent.props.onChange(formData, data);
  };
  const headerProps = {
    noHeader,
    onlyToolbars,
    titleAndFilters,
    onFilterFormChange,
    filtersContent,
    toolbarActionsContent,
    entity
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ContainerHeader, headerProps), children.find(x => x.type.name === Content.name), modalsContent);
};
ContentContainer.propTypes = {
  status: PropTypes.number,
  entity: PropTypes.string,
  data: PropTypes.array,
  columns: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string,
    options: PropTypes.object
  }))
};
export default ContentContainer;